import React from 'react'

import { Card } from '@/components/cards/Card'
import { Button } from '@/components/buttons/Button'

export const DesktopModeButtonGroup = ({ alwaysStartCall, visibility, handleModalChange }) => {
  const baltoZero = {
    desktop_always_start_call: false,
    desktop_visibility: false,
  }

  const baltoLite = {
    desktop_always_start_call: true,
    desktop_visibility: false,
  }

  const baltoStandard = {
    desktop_always_start_call: false,
    desktop_visibility: true,
  }

  return (
    <Card style={{ minWidth: 'fit-content' }}>
      <h3>Desktop Mode</h3>
      <div className="flex-align-center gap">
        <Button
          data-testid="balto-zero-button"
          onClick={() => handleModalChange(baltoZero, 'Change Desktop Mode to Balto Zero')}
          brand={!alwaysStartCall && !visibility}
        >
          Balto Zero
        </Button>
        <Button
          data-testid="balto-lite-button"
          onClick={() => handleModalChange(baltoLite, 'Change Desktop Mode to Balto Lite')}
          brand={alwaysStartCall && !visibility}
        >
          Balto Lite
        </Button>
        <Button
          data-testid="standard-balto-button"
          onClick={() => handleModalChange(baltoStandard, 'Change Desktop Mode to Balto Standard')}
          brand={!alwaysStartCall && visibility}
        >
          Standard Balto
        </Button>
      </div>
    </Card>
  )
}
